import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';

const { Box, ActionButton, IconButton } = designSystem;

const DifmOrderFormHeader = ({
  backButtonLabel,
  showBackButton,
  isDesktopView,
  onBackButtonClick,
  onCloseButtonClick,
}) => (
  <div className="ws-difm-order-form-header">
    <Box
      {...(isDesktopView
        ? { padding: 'spacing-xs' }
        : { padding: 'spacing-xs', paddingTop: 'spacing-2-xs' })}
    >
      <div
        className={classNames('ws-difm-order-form-header__box', {
          'ws-difm-order-form-header__box--with-back-button': showBackButton,
        })}
      >
        {showBackButton && (
          <ActionButton
            format="text"
            iconGlyph="back"
            size="small"
            label={backButtonLabel}
            onClick={onBackButtonClick}
          />
        )}
        <IconButton glyph="close" size="medium" transparent onClick={onCloseButtonClick} />
      </div>
    </Box>
  </div>
);

DifmOrderFormHeader.propTypes = {
  backButtonLabel: PropTypes.string.isRequired,
  showBackButton: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
};

export default DifmOrderFormHeader;
